import Modal from "react-bootstrap/Modal";
import { UserNoteCreation } from "../components/UserNoteCreation";

const UserNoteCreateUpdateModal = ({ visible, close, user, note }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          {note !== null && note !== undefined ? "Update" : "Add"} Note to{" "}
          {user?.surname}, {user?.forename}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserNoteCreation
          userNote={note}
          defaultUser={user}
          onComplete={(c) => {
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserNoteCreateUpdateModal;
